import {
  NgModule,
  ModuleWithProviders,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyHttpInterceptor } from './interceptors/my-http-interceptor';
import { AuthGuard } from './guard/auth.guard';
import { AuthService } from './services/auth.service';
import { HttpService } from './services/http.service';
import { SecurityService } from './services/security.service';
import { FormService } from './services/form.service';
import { DataService } from './services/data.service';
import { SessionService } from './services/session.service';
import { PreLoadRouteStrategy } from './strategy/pre-load-route-strategy';
import { SelectiveLoadRouteStrategy } from './strategy/selective-load-route-strategy';
import EventService from './services/event.service';
import { TranslateModule } from '@ngx-translate/core';
import { JsencryptService } from './services/jsencrypt.service';

@NgModule({
  imports: [CommonModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        AuthGuard,
        AuthService,
        HttpService,
        TitleCasePipe,
        DataService,
        SessionService,
        SecurityService,
        JsencryptService,
        FormService,
        EventService,
        PreLoadRouteStrategy,
        SelectiveLoadRouteStrategy,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MyHttpInterceptor,
          multi: true,
        },
      ],
    };
  }
}
